// When true, the brand strip only scrolls through the first MAX_BRANDS_TO_DISPLAY brands.
export const LIMIT_BRANDS_SCROLL = true

// Brand cards are square. The brand strip uses these to calculate which cards to mount.
export const BRAND_SIZE = 200
